import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { FormContainer } from '@shared/classes/form-container';
import { SEATS_AMOUNT_INPUT_CONFIG } from '@shared/components/delivery-pallets/components/delivery-pallet-seats/delivery-pallet-seats.constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'np-inv-delivery-pallet-seats',
  templateUrl: './delivery-pallet-seats.component.html',
  styleUrls: ['./delivery-pallet-seats.component.scss'],
})
export class DeliveryPalletSeatsComponent extends FormContainer implements OnDestroy {
  protected readonly SEATS_AMOUNT_INPUT_CONFIG = SEATS_AMOUNT_INPUT_CONFIG;

  seatsValue = '1';

  @Input() controlName = SEATS_AMOUNT_INPUT_CONFIG.controlName;
  @Output() seatsChange = new EventEmitter();

  constructor(protected fb: UntypedFormBuilder) {
    super();
  }

  @Input()
  get seats(): string {
    return this.seatsValue;
  }

  set seats(val: string) {
    this.seatsValue = val;
    this.seatsChange.emit(this.seatsValue);
  }

  addFormControls(): void {
    this.form.setControl(this.controlName, this.fb.control('1', [Validators.required, Validators.min(SEATS_AMOUNT_INPUT_CONFIG.minValue)]));
    this.subscriptions = this.form.get(this.controlName).valueChanges.subscribe((v) => (this.seats = v));
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.form?.removeControl(this.controlName);
  }
}
